import { render, staticRenderFns } from "./AppResumeItem.vue?vue&type=template&id=16acfc48&scoped=true&"
import script from "./AppResumeItem.vue?vue&type=script&lang=js&"
export * from "./AppResumeItem.vue?vue&type=script&lang=js&"
import style0 from "./AppResumeItem.vue?vue&type=style&index=0&id=16acfc48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16acfc48",
  null
  
)

export default component.exports